const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { shorturl: shorturlApi } = require('@doctoroncallcom/api')
const {
  GET_SHORTURL_LIST,
  GET_SHORTURL,
  CREATE_SHORTURL,
  UPDATE_SHORTURL,
  DELETE_SHORTURL,
} = require('./constants')

const {
  getShorturlListSuccess,
  getShorturlListError,
  getShorturlSuccess,
  getShorturlError,
  createShorturlSuccess,
  createShorturlError,
  updateShorturlSuccess,
  updateShorturlError,
  deleteShorturlSuccess,
  deleteShorturlError,
} = require('./actions')

const getShorturlList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_SHORTURL_LIST),
  mergeMap(action => shorturlApi.getShorturlListApi(api, {
    take: action.payload.take,
    skip: action.payload.skip,
  })
    .then(response => getShorturlListSuccess(response.data))
    .catch(error => getShorturlListError(error))),
)

const getShorturl = (action$, state$, { api }) => action$.pipe(
  ofType(GET_SHORTURL),
  mergeMap(action => shorturlApi.getShorturlApi(api, action.payload.id)
    .then(response => getShorturlSuccess(response.data))
    .catch(error => getShorturlError(error))),
)

const createShorturl = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_SHORTURL),
  mergeMap(action => shorturlApi.createShorturlApi(api, action.payload.shorturlData)
    .then(response => createShorturlSuccess(response.data))
    .catch(error => createShorturlError(error))),
)

const updateShorturl = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_SHORTURL),
  mergeMap(action => shorturlApi.updateShorturlApi(api, action.payload.id,
    action.payload.shorturlData)
    .then(response => updateShorturlSuccess(response.data))
    .catch(error => updateShorturlError(error))),
)

const deleteShorturl = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_SHORTURL),
  mergeMap(action => shorturlApi.deleteShorturlApi(api, action.payload.id)
    .then(response => deleteShorturlSuccess(response.data))
    .catch(error => deleteShorturlError(error))),
)

module.exports = {
  getShorturlList,
  getShorturl,
  createShorturl,
  updateShorturl,
  deleteShorturl,
}
